import { useCentralApi, useCurrentUser } from "hooks/shared";
import { toPascalCase } from "utils/string-utils";

const useProjectWorkItemsWorkflowsExport = (projectId: string | undefined, workItemStatus: string) => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const fileName = `Work Items and Workflows - ${toPascalCase(workItemStatus)}`;
    
    const handleExport = async () => {
        const resp = await fetcher(`/api/v3.0/projects/export/${projectId}/workitems/${workItemStatus}/all`, {
            method: 'POST'
        });

        const blob = new Blob([await resp.blob()], { type: "text/csv" });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();        
    };

    return handleExport;
}

export default useProjectWorkItemsWorkflowsExport;